define((require) => {
    "use strict";

    const $     = require("jquery");
    const Class = require("shared/util/Class");

    const BASE_URL = "https://www.youtube.com/iframe_api";

    /**
     * Gets the YouTube IFrame Player API.
     *
     * @see https://developers.google.com/youtube/iframe_api_reference?hl=en
     *
     * @class YouTubeIframeAPI
     * @author Jens Svensson
     */
    const YouTubeIframeAPI = Class.extend({

        _deferred: null,

        _loadPerformed: false,

        /**
         * Constructor.
         */
        constructor() {
            this._deferred = new $.Deferred();
        },

        /**
         * Starts loading the YouTube IFrame Player API.
         *
         * @return {Promise} A promise that resolves with the YouTube IFrame Player API
         * instance.
         */
        load() {
            if (!this._loadPerformed) {
                this._startFetching();
            }
            // Guard for future loads
            this._loadPerformed = true;
            // Return a promise
            return this._deferred.promise();
        },

        /**
         * @private
         *
         * Starts fetching the YouTube IFrame Player API, and resolves the deferred
         * object if the load was successful.
         */
        _startFetching() {
            // Create callback in the global scope
            window.onYouTubeIframeAPIReady = () => {
                // Cleanup and resolve
                delete window.onYouTubeIframeAPIReady;
                this._deferred.resolve(window.YT);
            };

            // Load the client library
            $.getScript(BASE_URL).fail(this._deferred.reject);
        }

    });

    return new YouTubeIframeAPI();
});



// WEBPACK FOOTER //
// ./src/shared/services/YouTubeIframeAPI.js